import { unset, upperCase } from "lodash";
import React from "react";
import { Button, Spinner, FormSelect } from 'react-bootstrap';

class ReferenceImageView extends React.PureComponent {

  render() {
    const { referenceImages } = this.props;
    return (
      <div className="reference-image-view" style={{ backgroundColor: '#f3f3f3', border: 'dashed darkgray 1px', padding: '10px', borderRadius: '4px' }}>
        {referenceImages && referenceImages.length > 0 ? (
          <div className="reference-images-container flex flex-row gap-2" style={{ marginTop: '10px', overflowX: 'auto' }}>
            {referenceImages.map((image, index) => (
              <div key={index} className="reference-image-wrapper position-relative" style={{ display: 'inline-block' }}>
                <img
                  src={image.dataUrl}
                  alt={`Reference ${index + 1}`}
                  className="reference-image"
                  style={
                    { width: '150px', height: '150px', objectFit: 'cover', borderRadius: '4px' }
                  } />
                <button className="btn btn-sm btn-danger" type="button" style={{ position: 'absolute', top: '5px', right: '5px' }} onClick={() => this.props.onRemoveReferenceImage(index)}>
                  &times;
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">{this.props.messages.editor.no_reference_images || "No reference images added yet."}</p>
        )}
      </div>
    );
  }
}

export default ReferenceImageView;